import { render } from "./Product3DFiles.vue?vue&type=template&id=31983cd6&scoped=true"
import script from "./Product3DFiles.vue?vue&type=script&lang=js"
export * from "./Product3DFiles.vue?vue&type=script&lang=js"

import "./Product3DFiles.vue?vue&type=style&index=0&id=31983cd6&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31983cd6"]])

export default __exports__